import { cn } from '@latitude/token-utils';
import * as ToastPrimitives from '@radix-ui/react-toast';
import type { ComponentPropsWithoutRef, ComponentRef, Ref } from 'react';

/**
 * Represents the title component of a toast.
 *
 * @component
 * @example
 * ```tsx
 * <ToastTitle className="custom-title" />
 * ```
 */
export const ToastTitle = ({
  className,
  ref,
  ...props
}: ComponentPropsWithoutRef<typeof ToastPrimitives.Title> & {
  ref?: Ref<ComponentRef<typeof ToastPrimitives.Title>>;
}) => {
  return (
    <ToastPrimitives.Title
      ref={ref}
      className={cn(
        [
          'break-words',
          'line-clamp-2',
          'text-ellipsis',
          'overflow-hidden',
          'whitespace-normal',
          'font-ref-web-body-medium-font-family',
          'font-ref-body-bold-font-weight',
          'text-font-ref-body-medium-font-size',
          'tracking-font-ref-web-body-medium-letter-spacing',
          'leading-ref-web-body-medium-line-height',
        ],
        className,
      )}
      {...props}
    />
  );
};
ToastTitle.displayName = ToastPrimitives.Title.displayName;
